
export default {
  props: {
    kontak: Boolean,
  },
};
